import * as React from "react"

import Home from "../components/update"
import Seo from "../components/seo"

const SekolahPage = () => (
<Home>
<Seo title="Aplikasi Sekolah" />

<div className="container">
<div className="row mt-5">
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">
<h1><strong><a href="/sekolah/">Aplikasi Sekolah</a></strong></h1>
<h2>Sekolah app dengan siswa wali murid guru e-learn admin all in one.</h2>
<p>Memudahkan dalam pihak sekolah dalam pencatatan pembukuan , mulai dari daftar siswa, proses belajar mengajar, tugas tugas online, penilaian, status pembayaran keuangan , dan berbagai kebutuhan lain nya, dengan kemudahan pembagian divisi app untuk kebutuhan siswa khusus para siswa dan orang tua wali murid cek tugas dan status pembayaran nya, untuk guru bekerja dalam memberikan penilaian dan tugas sekolah, untuk tata usaha dalam kebutuhan input pembayaran keuangan sekolah, hingga admin office untuk hak akses penuh kuasa akan semua nya, termasuk membuat event dan agenda update mengenai sekolah.</p>
</div>
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/playlist?list=PLQDm6k9_HvYPvK5GDjK4BJNaxShM3lHR8" title="Aplikasi sekolah"></iframe>
</div>
</div>
</div>
</div>

</Home>
)

export default SekolahPage